<script setup lang="ts">
import logoUrl from '@brand-logo'
import CompanyPicker from '@/components/CompanyPicker.vue'
import LoginForm from '@/components/LoginForm.vue'
import { activeBrand } from '@/lib/activeBrand'
import SignedOut from '@/components/SignedOut.vue'
import { readAppConfig } from '@/lib/config'
import { readReturnTarget } from '@/lib/returnTarget'
import { resolveScreen } from '@/lib/screen'
import { readSignInError } from '@/lib/signInError'
import { readSignOutContinuation } from '@/lib/signedOutNavigation'

const brand = activeBrand()
const config = readAppConfig()
const returnUrl = readReturnTarget(window.location.search)
const signInError = readSignInError(window.location.search)
const continuation = readSignOutContinuation(window.location.search)

// Resolves against the build-time base.
const appBase = import.meta.env.BASE_URL
const screen = resolveScreen(window.location.pathname, appBase)
const year = new Date().getFullYear()
</script>

<template>
  <SignedOut
    v-if="screen === 'signed-out'"
    :brand-name="brand.name"
    :logo-url="logoUrl"
    :return-url="returnUrl"
    :continuation="continuation"
    :complete-signout-url="config.completeSignoutUrl"
  />

  <CompanyPicker
    v-else-if="screen === 'companies'"
    :app-base="appBase"
    :brand-name="brand.name"
    :logo-url="logoUrl"
    :return-url="returnUrl"
    :status-endpoint="config.sessionStatusEndpoint"
    :context-endpoint="config.sessionContextEndpoint"
    :logout-url="config.logoutUrl"
  />

  <template v-else>
    <main class="shell">
      <section
        class="card"
        data-testid="sign-in-card"
      >
        <img
          class="card__logo"
          :src="logoUrl"
          :alt="brand.name"
        >
        <h1 class="card__title">
          Login
        </h1>

        <LoginForm
          :return-url="returnUrl"
          :challenge-endpoint="config.challengeEndpoint"
          :sign-in-error="signInError"
          :forgot-password-url="config.forgotPasswordUrl"
        />
      </section>
    </main>

    <footer
      class="page-foot"
      data-testid="page-foot"
    >
      © {{ year }} - {{ brand.operator }}
    </footer>
  </template>
</template>
